/**
 * All ten input slots released. Handed to entities that must not react this
 * frame. `Knight.update` writes `false` into slots 0-3 of whatever it is given,
 * which is a no-op here, so the one array can safely be shared.
 */
// prettier-ignore
export const NO_INPUT: boolean[] = [false, false, false, false, false, false, false, false, false, false];

/**
 * Keyboard codes the game polls each frame, mapped to their slot in the input
 * array: 0-3 movement, 4 action, 5-9 weapon select.
 */
export const KEY_BINDINGS: readonly {
  readonly codes: readonly number[];
  readonly slot: number;
}[] = [
  { codes: [38, 87], slot: 0 },
  { codes: [40, 83], slot: 1 },
  { codes: [37, 65], slot: 2 },
  { codes: [39, 68], slot: 3 },
  { codes: [32], slot: 4 },
  { codes: [49], slot: 5 },
  { codes: [50], slot: 6 },
  { codes: [51], slot: 7 },
  { codes: [52], slot: 8 },
  { codes: [53], slot: 9 },
];
